export const MANUFACTURERS = [
  'Manufacturer 1',
  'Manufacturer 2',
  'Manufacturer 3',
  'Manufacturer 4',
  'Manufacturer 5',
];

export const DEVICES = [
  'Device 1',
  'Device 2',
  'Device 3',
  'Device 4',
  'Device 5',
];

export const LOCATIONS = [
  'Location 1',
  'Location 2',
  'Location 3',
  'Location 4',
  'Location 5',
];

export const PRODUCT_FAMILIES = [
  'Warranty',
  'Device Monitoring',
  '4K Streaming',
  'Additional Ports',
];

export const MODELS = [
  'AC-AXION-4',
  'AC-CX62-AUHD',
  'AC-MX88-AUHD',
  'AC-MX54-AUHD',
  'AC-AXION-8',
];

export const PRODUCTS = [
  'Warranty',
  'Extended Warranty',
  'Additional HDMI Port',
  '4K Support',
  'Additional DVI port',
];

export const COMPANIES = [
  'Customer A',
  'Customer B',
  'Customer C',
  'Customer D',
];
